import styled from '@emotion/styled'
import { colors, font, radius } from '@mobi/component-library/Foundations'
import { Money } from '@core/Components/Text/Money'

export const BalanceInfoBarContainerStyled = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  boxSizing: 'border-box',
  height: '3rem',
  paddingBottom: '1rem',
  fontSize: '1.4rem',
})

export const BalanceInfoBarStyled = styled.span({
  color: colors.white,
})

export const BonusBalanceMoneyStyled = styled
  .div({
    backgroundColor: colors.celery[50],
    color: colors.success[600],
    fontFamily: font.family.primary,
    fontSize: font.size.md.fontSize,
    fontWeight: font.weight.medium,
    lineHeight: font.size.md.lineHeight,
    borderRadius: radius.smx1,
    textAlign: 'left',
    padding: '0 0.2rem',
    marginLeft: '0.8rem',
  })
  .withComponent(Money)
